export default "__VITE_ASSET__81a03e2f__"